import { render } from "./PreLoaderSection.vue?vue&type=template&id=4cb300a6&scoped=true"
import script from "./PreLoaderSection.vue?vue&type=script&lang=js"
export * from "./PreLoaderSection.vue?vue&type=script&lang=js"

import "./PreLoaderSection.vue?vue&type=style&index=0&id=4cb300a6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb300a6"]])

export default __exports__